import kaboom from 'kaboom';

// initialize context
kaboom({
  background: [0, 0, 0],
});

loadSprite('question', 'question.png');
loadSprite('block', 'block.png');
loadSprite('pipe-top-left-side', 'pipe-top-left-side.png');
loadSprite('pipe-top-right-side', 'pipe-top-right-side.png');
loadSprite('evil-shroom-1', 'evil-shroom-1.png');
loadSprite('pipe-left', 'pipe-left.png');
loadSprite('pipe-right', 'pipe-right.png');
loadSprite('brick', 'brick.png');
loadSprite('mario-standing', 'mario-standing.png');
loadSprite('coin', 'coin.png');
loadSprite('unboxed', 'unboxed.png');
loadSprite('mushroom', 'mushroom.png');

//level 2
loadSprite('blue-brick', 'blue-brick.png');
loadSprite('blue-block', 'blue-block.png');
loadSprite('blue-surprise', 'blue-surprise.png');
loadSprite('blue-evil-shroom', 'blue-evil-shroom.png');
loadSprite('blue-steel', 'blue-steel.png');

scene('game', (level, score) => {
  const JUMP_FORCE = 360;
  const BIG_JUMP_FORCE = 550;
  const MOVE_SPEED = 120;
  const ENEMY_SPEED = 20;
  const FALL_DEATH = 600;

  let CURRENT_JUMP_FORCE = JUMP_FORCE;
  let isJumping = true;
  layers(['obj', 'ui'], 'obj');

  const maps = [
    [
      '                        ',
      '                        ',
      '                        ',
      '                        ',
      '                        ',
      '    %   =*=%=           ',
      '                        ',
      '                 -+     ',
      '        ^       ^()     ',
      'xxxxxxxxxxxxxxxxxxx  xxx',
    ],
    [
      '£                          £',
      '£                          £',
      '£                          £',
      '£                          £',
      '£                          £',
      '£     @@@@@@       s       £',
      '£                s s s     £',
      '£              s s s s   -+£',
      '£    !       s s s s s   ()£',
      'zzzzzzzzzzzzzzzzzzzzzzzzzzzz',
    ],
  ];

  const levelCfg = {
    width: 20,
    height: 20,
    '=': () => [sprite('block'), area(), solid()],
    x: () => [sprite('brick'), area(), solid()],
    $: () => [sprite('coin'), 'coin', area()],
    '%': () => [sprite('question'), 'coin-surprise', area(), solid()],
    '*': () => [sprite('question'), 'mushroom-surprise', area(), solid()],
    '}': () => [sprite('unboxed'), area(), solid()],
    '(': () => [sprite('pipe-left'), scale(0.5), area(), solid()],
    ')': () => [sprite('pipe-right'), scale(0.5), area(), solid()],
    '-': () => [
      sprite('pipe-top-left-side'),
      scale(0.5),
      area(),
      solid(),
      'pipe',
    ],
    '+': () => [
      sprite('pipe-top-right-side'),
      scale(0.5),
      area(),
      solid(),
      'pipe',
    ],

    '^': () => [sprite('evil-shroom-1'), area(), solid(), 'dangerous'],
    '#': () => [sprite('mushroom'), 'mushroom', body(), area()],
    '£': () => [sprite('blue-brick'), scale(0.5), area(), solid()],
    z: () => [sprite('blue-block'), scale(0.5), area(), solid()],
    '@': () => [
      sprite('blue-surprise'),
      scale(0.5),
      area(),
      solid(),
      'coin-surprise',
    ],
    '!': () => [
      sprite('blue-evil-shroom'),
      scale(0.5),
      area(),
      solid(),
      'dangerous',
    ],
    s: () => [sprite('blue-steel'), scale(0.5), area(), solid()],
  };

  let levelIndex = level ?? 0;
  const gameLevel = addLevel(maps[levelIndex], levelCfg);

  let scoreGlobal = 0;
  const scoreLabel = add([
    text('score: ' + scoreGlobal, { size: 15, font: 'sink' }),
    pos(30, 6),
    layer('ui'),
    {
      value: scoreGlobal,
    },
  ]);

  add([
    text('level ' + parseInt(levelIndex + 1), { size: 15, font: 'sink' }),
    pos(30, 30),
  ]);

  const player = add([
    sprite('mario-standing'),
    pos(30, 0),
    area(),
    body(),
    big(),
  ]);

  function big() {
    let timer = 0;
    let isBig = false;

    return {
      update() {
        if (isBig) {
          timer -= dt();
          if (timer <= 0) {
            this.smallify();
          }
        }
      },
      isBig() {
        return isBig;
      },
      smallify() {
        this.scale = vec2(1);
        timer = 0;
        isBig = false;
        CURRENT_JUMP_FORCE = JUMP_FORCE;
      },
      biggify(time) {
        this.scale = vec2(2);
        timer = time;
        isBig = true;
        CURRENT_JUMP_FORCE = BIG_JUMP_FORCE;
      },
    };
  }

  player.collides('dangerous', (d) => {
    if (isJumping) {
      destroy(d);
    } else {
      go('lose', scoreGlobal);
    }
  });

  player.action(() => {
    camPos(player.pos);
    if (player.pos.y >= FALL_DEATH) {
      go('lose', scoreGlobal);
    }
  });

  onKeyDown('a', () => {
    player.move(-MOVE_SPEED, 0);
  });

  onKeyDown('d', () => {
    player.move(MOVE_SPEED, 0);
  });

  player.action(() => {
    if (player.grounded()) {
      isJumping = false;
    }
  });

  onKeyPress('space', () => {
    if (player.grounded()) {
      isJumping = true;
      player.jump(CURRENT_JUMP_FORCE);
    }
  });

  player.onHeadbutt((obj) => {
    if (obj.is('coin-surprise')) {
      gameLevel.spawn('$', obj.gridPos.sub(0, 1));
      destroy(obj);
      gameLevel.spawn('}', obj.gridPos.sub(0, 0));
    }
    if (obj.is('mushroom-surprise')) {
      gameLevel.spawn('#', obj.gridPos.sub(0, 1));
      destroy(obj);
      gameLevel.spawn('}', obj.gridPos.sub(0, 0));
    }
  });

  action('mushroom', (m) => {
    m.move(20, 0);
  });

  player.collides('mushroom', (m) => {
    player.biggify(6);
    destroy(m);
  });

  player.collides('coin', (c) => {
    scoreLabel.value++;
    scoreLabel.text = scoreLabel.value;
    destroy(c);
  });

  action('dangerous', (d) => {
    d.move(-ENEMY_SPEED, 0);
  });

  player.collides('pipe', () => {
    keyPress('s', () => {
      go('game', (levelIndex + 1) % maps.length, scoreLabel.value);
    });
  });
});

scene('lose', (score) => {
  add([
    text(score, { font: 'sink' }),
    origin('center'),
    pos(width() / 2, height() / 2),
    scale(5),
  ]);
});

go('game');

// debug.inspect = true
